module.exports = __webpack_public_path__ + "img/3@2x.dd941fc.webp";